/*!
 * Built by Revolist OU ❤️
 */
import './index-InvwFkCn.js';

const globalFn = () => { };

const globalScripts = globalFn;

export { globalScripts as g };
//# sourceMappingURL=app-globals-CKsR1AEW.js.map

//# sourceMappingURL=app-globals-CKsR1AEW.js.map